export const MERGE_PROCESS_STATE_GLOBAL_STATE_KEY = "merge-process-state"
export const UPDATE_MERGE_PROCESS_STATE_ACTION = "update-merge-process-state-action"
